<div class="input-select" ngClass="{{!!displayLabel ? 'form-group' : ''}}">
  <label [ngClass]="isRequired ? 'required ' + clsLabel : clsLabel" [for]="id" *ngIf="!!displayLabel">
    {{displayLabel}}<span class="required-alert" *ngIf="!!isRequired">*</span>
  </label>
  <div class="col-form-input input-group">
    <ng-select [id]="id" [formControl]="control" [required]="isRequired" class="form-control custom"
      [placeholder]="placeholder" [appendTo]="container" [items]="suggestions$ | async" [typeahead]="recordInput$"
      [bindValue]="valueField" [bindLabel]="displayField" [groupBy]="groupField"
      [addTag]="false" [multiple]="false" [hideSelected]="false" [trackByFn]="trackByFn"
      [minTermLength]="minLengthToSearch" [loading]="recordLoading" [readonly]="readOnly"
      [typeToSearchText]="getTypeToSearchText()" clearAllText="Limpar" (open)="onOpen($event)"
      (change)="onChange($event)" (ngModelChange)="onModelChange($event)" (search)="onSearch($event)">
      <ng-template ng-loadingspinner-tmp>
        <div class="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </ng-template>
      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">"{{ searchTerm }}" não encontrado</div>
        <button type="button" class="btn btn-success" (click)="onAddNewClick(searchTerm)" *ngIf="canAddNew">
          <i class="fa fa-plus" ar2531
          ia-hidden="true" title="Novo Registro"></i>
        </button>
      </ng-template>
    </ng-select>
    <span class="input-group-text" *ngIf="rightText">{{ rightText }}</span>
    <ng-content></ng-content>
  </div>

  <!-- <p> {{ control?.value | json }}</p> -->

  <!-- <app-field-error-display *ngIf="errorMsg" [displayError]="isFieldInvalid()" [errorMsg]="errorMsg">
  </app-field-error-display> -->
</div>
